<template>
  <div id="users-table">
    <b-loading style="z-index: 100;" :is-full-page="true" :can-cancel="false">
      <div class="loading-container">
        <div class="loading">
          <p>loading</p>
          <span></span>
        </div>
      </div>
    </b-loading>

    <b-table :data="(users && users.length == 0) ? [] : users" striped narrowed hoverable
      :checked-rows.sync="selectedUsers" :mobile-cards="hasMobileCards" searchable checkable paginated pagination-simple
      :per-page="perPage" pagination-position="bottom" :current-page.sync="currentPage" sort-icon="arrow-up"
      sort-icon-size="is-small" default-sort-direction="asc" default-sort="firstName">
      <b-table-column v-slot="props" field="firstName" label="First Name" sortable searchable>
        <div :class="selectedUsers.includes(props.row) ? 'bold-text' : ''">
          {{ props.row.firstName }}
        </div>
      </b-table-column>

      <b-table-column v-slot="props" field="lastName" label="Last Name" sortable searchable>
        <div :class="selectedUsers.includes(props.row) ? 'bold-text' : ''">
          {{ props.row.lastName }}
        </div>
      </b-table-column>

      <b-table-column v-slot="props" field="preferredName" sortable label="Preferred Name" searchable>
        <div :class="selectedUsers.includes(props.row) ? 'bold-text' : ''">
          {{
            props.row.preferredName != null ? props.row.preferredName : "-"
          }}
        </div>
      </b-table-column>

      <b-table-column v-slot="props" field="email" sortable label="Email" searchable>
        <div :class="selectedUsers.includes(props.row) ? 'bold-text' : ''">
          {{ props.row.email }}
        </div>
      </b-table-column>

      <b-table-column v-slot="props" field="class" label="Class" sortable searchable>
        <div :class="selectedUsers.includes(props.row) ? 'bold-text' : ''">
          {{ props.row.class != null ? props.row.class : "-" }}
        </div>
      </b-table-column>

      <b-table-column v-slot="props" field="grade" label="Grade" searchable>
        <div :class="selectedUsers.includes(props.row) ? 'bold-text' : ''">
          {{ props.row.grade }}
        </div>
      </b-table-column>

      <b-table-column v-slot="props" field="country" label="Country" style="width:150px" searchable>
        <div :class="selectedUsers.includes(props.row) ? 'bold-text' : ''">
          {{ props.row.country != null ? props.row.country : "-" }}
        </div>
      </b-table-column>

      <b-table-column v-slot="props" field="subscription" label="Subscription" centered>
        <div :class="selectedUsers.includes(props.row) ? 'bold-text' : ''">
          {{
            props.row.subscription.endDate != null
              ? props.row.subscription.endDate.toString().substring(0, 10)
              : "-"
          }}
        </div>
      </b-table-column>

      <b-table-column v-slot="props">
        <b-button v-if="viewPage === 'users'" id="editBtn" type="is-text" outlined :disabled="selectedUsers.length > 1"
          @click="showEditModal(props.row)">Edit</b-button>

        <b-button v-if="viewPage === 'archive'" id="archiveBtn" type="is-text" outlined
          :disabled="selectedUsers.length > 1" @click="archiveLearner(props.row.email)"
          class="is-size-7">Archive</b-button>
      </b-table-column>
    </b-table>

    <div>
      <b-button v-if="viewPage === 'users'" id="tableBtn" @click="confirmChanges()"
        :type="changes.length > 0 ? 'is-primary' : ''" class="tag is-primary" :outlined="changes.length == 0"
        size="is-medium">Confirm Changes</b-button>
      <b-button v-if="viewPage === 'archive'" id="tableBtn" @click="archiveLearners(selectedUsers)"
        :type="changes.length > 0 ? 'is-primary' : ''" class="tag is-primary" :outlined="changes.length == 0"
        size="is-medium">Archive Learners</b-button>

      <b-button v-if="viewPage === 'users'" id="tableBtn" @click="showEditModal()" outlined
        :disabled="selectedUsers.length < 2" class="tag is-dark" size="is-medium">Edit Selected</b-button>
      <b-button v-if="viewPage === 'users'" id="tableBtn" @click="resetTable()" outlined class="tag is-dark"
        size="is-medium">Discard Changes</b-button>
    </div>

    <div v-if="isModalActive">
      <both-card v-on:closeModal="hideEditModal" :selectedUsers="selectedUsers" :changedUser="{ ...changedUser }"
        :isModalActive="isModalActive" v-on:passEditedUser="storeChanges"></both-card>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import EditBothCard from "./EditBothCard.vue";
import loadash from "lodash";

export default {
  props: {
    viewPage: String
  },
  components: {
    "both-card": EditBothCard
  },
  data() {
    return {
      hasMobileCards: false,
      selectedUsers: [],
      userID: 1,
      users: [],
      changes: [],
      changedUser: null,
      isModalActive: false,
      bulkModalActive: false,
      perPage: 15,
      currentPage: 1,
      isEmpty: false,
      placeholders: false
    };
  },

  computed: {
    ...mapGetters({
      data: "globalStore/getFilteredList",
      getChangeUserData: "globalStore/getChangeUserData"
    })
  },
  mounted() {
    // console.log('this.data', this.data);
    this.users = this.data.map(o => ({ ...o }));
    // console.log("users", this.users);

    if (this.getChangeUserData.length > 0) {
      this.users = this.filterArray(this.users, this.getChangeUserData);
    }
  },
  created() {
    this.$nextTick(function () {
      let searchbars = document.getElementsByClassName("control is-clearfix");
      Array.from(searchbars).forEach(element => {
        if (!element.className.includes("icon")) {
          element.firstChild.placeholder = "Search here...";
        }
      });
    });
  },
  methods: {
    ...mapActions({
      updateUsers: "globalStore/updateUsers",
      archiveLearnersByEmail: "globalStore/archiveByEmail",
      loading: "SET_SCREEN_LOADING"
    }),
    uniqueValues(value, index, self) {
      return self.indexOf(value) === index;
    },
    searchBars() {
      let searchbars = document.getElementsByClassName("control is-clearfix");
      Array.from(searchbars).forEach(element => {
        if (!element.className.includes("icon")) {
          element.firstChild.placeholder = "Search here...";
        }
      });
      return true;
    },
    storeChanges(val) {
      if (this.findUserInArray(val, this.changes)) {
        let tempUser = {};
        tempUser = this.findUserInArray(val, this.changes);
        this.updateLearnerVals(tempUser, val);
      }
      let otherUser = this.findUserInArray(val, this.users);
      this.updateLearnerVals(otherUser, val);
      this.changes.push(val);
      this.hideEditModal();
    },
    showEditModal(val) {
      this.changedUser = val;
      this.isModalActive = true;
      if (!this.placeholders) {
        let searchbars = document.getElementsByClassName("control is-clearfix");

        Array.from(searchbars).forEach(element => {
          if (!element.className.includes("icon")) {
            element.firstChild.placeholder = "Search here...";
          }
          this.placeholders = true;
        });
      }
    },
    archiveLearner(value) {
      const learnerEmail = value;

      const email = [{ email: learnerEmail }];

      this.$buefy.dialog.confirm({
        title: "Archive Learner",
        message:
          "Are you sure you want to archive learner <b>" + value + "</b> ?",
        confirmText: "Archive Learner",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.archiveSelectedLearners(email)
      });
    },
    archiveLearners(value) {
      const learnerEmails = value.map(user => {
        return { email: user.email };
      });

      if (learnerEmails.length > 0) {
        this.$buefy.dialog.confirm({
          title: "Archiving Learners",
          message:
            "Are you sure you want to archive <b>" +
            learnerEmails.length +
            "</b> learners?",
          confirmText: "Archive Learners",
          type: "is-danger",
          hasIcon: true,
          onConfirm: () => this.archiveSelectedLearners(learnerEmails)
        });
      }
    },
    async archiveSelectedLearners(learnerEmails) {
      if (learnerEmails.length > 0) {
        this.loading(true);
        let request = await this.archiveLearnersByEmail(
          learnerEmails,
          this.users
        );
        this.loading(false);

        if (request) {
          this.selectedUsers = [];
          this.users = this.filterArray(this.users, learnerEmails);

          this.$buefy.toast.open({
            message: "Archiving was Successful",
            type: "is-success",
            duration: 4500
          });
        } else {
          this.$buefy.toast.open({
            message: "Archiving Failed",
            type: "is-danger",
            duration: 4500
          });
        }
      }
    },
    filterArray(users, filter) {
      let filteredObjects = loadash.differenceWith(
        users,
        filter,
        ({ email }, id) => email === id
      );
      return filteredObjects;
    },
    displayFiltered() {
      this.intervalid1 = setInterval(function () { }, 3000);
    },
    hideEditModal() {
      this.isModalActive = false;
    },
    resetTable() {
      if (this.changes.length > 0) {
        this.users = this.data.map(o => ({ ...o }));
        this.changes = [];
        this.selectedUsers = [];
        this.$buefy.toast.open({
          message: "Changes discarded. Values in table have been reset.",
          type: "is-info"
        });
      }
    },
    findUserInArray(user, array) {
      return array.find(element => element._id === user._id);
    },
    updateLearnerVals(element, val) {
      Object.keys(val).forEach(key => {
        element[key] = val[key];
      });
    },
    async confirmChanges() {
      if (this.changes.length > 0) {
        this.loading(true);
        let updateStatus = await this.updateUsers(this.changes);
        //disabling loader.
        this.loading(false);
        if (updateStatus) {
          //clear both arrays
          this.selectedUsers = [];
          this.changes = [];

          this.$buefy.toast.open({
            message: "Users Updated Successfully",
            type: "is-success"
          });
        } else {
          this.$buefy.toast.open({
            message: "Failed to Update Users",
            type: "is-danger"
          });
          this.resetTable();
        }
      }
      this.changes = [];
    }
  },
  watch: {
    data: {
      handler: function () {
        this.users = this.data.map(o => ({ ...o }));
      }
    }
  }
};
</script>
